import { Component, OnInit } from '@angular/core';
import { Response } from '@angular/http';
import { ActivatedRoute } from '@angular/router';
import { Observable } from 'rxjs/Observable';

import { AuthHttpService } from '../../core/services/api/auth-http.service';
import { ValidationService } from '../../core/services/validation/validation.service';
import { ResetPasswordInterface } from './reset-password.interface';

@Component({
  selector: 'ltg-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.css']
})
export class ResetPasswordComponent implements OnInit {
  hash: string;
  done = false;
  resetPassword$: Observable<boolean>;
  fieldErrors: any;

  constructor(
    private authHttpService: AuthHttpService,
    private activeRoute: ActivatedRoute,
    private validationService: ValidationService
  ) { }

  ngOnInit() {
    this.hash = this.activeRoute.snapshot.params['hash'];
    this.resetPassword$ = this.activeRoute.data.pluck('resetPassword');
  }

  onResetPassword(resetPassword: ResetPasswordInterface) {
    this.fieldErrors = null;
    this.authHttpService.resetPassword(this.hash, resetPassword.password, resetPassword.passwordRepeat)
      .subscribe(this.onResetPasswordSuccess, this.onResetPasswordError);
  }

  private onResetPasswordSuccess = () => this.done = true;

  private onResetPasswordError = (response: Response) => {
    const data = response.json();
    this.validationService.showGlobalError(data.errors);
    this.fieldErrors = (data.errors) ? data.errors.fields : null;
  }
}



// WEBPACK FOOTER //
// /var/www/lantago-app/lantago-app-demo/src/app/auth/reset-password/reset-password.component.ts